import { DateRangeContainer } from './styled';
import PropTypes from 'prop-types';
import { downloadHeaders } from 'views/containers/StatisticsTurns/fixtures';
import moment from 'moment';
import { turnsActions } from 'core/Turns';
import { useTranslation } from 'react-i18next';
import {
    DateRangePicker,
    DownloadModal
} from 'mol-ui';
import React, { useState } from 'react';
import {
    useDispatch,
    useSelector
} from 'hooks';

const TurnDownloadModal = ({
    active,
    onClose
}) => {

    const dispatch = useDispatch();
    const { t } = useTranslation();
    const {
        downloadList: list,
        downloadStatus
    } = useSelector('turns');
    const loading = downloadStatus === 'loading';

    const [endDate, setEndDate] = useState(moment().endOf('month').format('YYYY-MM-DD'));
    const [startDate, setStartDate] = useState(moment().startOf('month').format('YYYY-MM-DD'));
    
    const onChange = (start, end) => {
        setStartDate(start);
        setEndDate(end);
    };

    const onDownload = () => {
        const data = {
            end_date: endDate,
            start_date: startDate
        };
        dispatch(turnsActions.getTurnsDownloadList(data));
    };

    return (
        <DownloadModal
            active={ active }
            data={ list }
            fileName={ `${ t('Turnos') } ${ startDate ? startDate : '' }${ endDate ? `-${ endDate }` : '' }` }
            headers={ downloadHeaders }
            height="300px"
            loading={ loading }
            width="400px"
            onFetchData={ onDownload }
            onToggle={ onClose }
        >
            <DateRangeContainer>
                <DateRangePicker
                    allowFutureDays={ true }
                    endValue={ endDate }
                    position="center"
                    startValue={ startDate }
                    onChange={ onChange }
                />
            </DateRangeContainer>
        </DownloadModal>
    );
};

TurnDownloadModal.propTypes = {
    active: PropTypes.bool,
    onClose: PropTypes.func
};

export default TurnDownloadModal;
